import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export const useSetQuoteApprovedTimestampHook = (): {
    setQuoteApprovedTimestamp: () => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const setQuoteApprovedTimestamp = async (): Promise<void> => {
        await OnlineSales.setQuoteApprovedTimestamp(jobNumber, sessionId);
    };

    return { setQuoteApprovedTimestamp };
};
